
import { Component, Vue, Prop } from "vue-property-decorator";
import { getDeviceList } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
import updataUpgradePack from "./updata-upgrade-pack.vue";
import devDetails from "./dev-details.vue";
import devDebug from "./dev-debug.vue";
@Component({
  components: {
    "updata-upgrade-pack": updataUpgradePack,
    "pi-dev-details": devDetails,
    "pi-dev-debug": devDebug
  }
})
export default class EquipmentTable extends Vue {
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private initData!: objAny;
  private updataUpgradePack: objAny = {};
  private devDetails: objAny = {};
  private devDebug: objAny = {};

  private formInline: objAny = {
    field: "",
    opr: "",
    deviceType: "",
    pageNo: 1,
    pageSize: 10,
    globalSearch: "",
    type: ""
  };
  private selectList: object[] = [];
  private total = 0;
  private loading = false;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 40,
      align: "center"
    },
    // {
    //   title: "序号",
    //   key: "index",
    //   width: 40,
    //   slot: "index"
    // },
    {
      title: "设备编号",
      key: "serialNumber",
      minWidth: 103
    },
    {
      title: "设备类型",
      key: "deviceTypeName",
      minWidth: 103
    },
    {
      title: "所属运营商",
      key: "oprName",
      minWidth: 83
    },
    {
      title: "设备型号",
      key: "deviceModel",
      minWidth: 140
    },
    {
      title: "生产编号",
      key: "batchNumber",
      minWidth: 90
    },
    {
      title: "生成日期",
      key: "batchDate",
      minWidth: 85
    },
    {
      title: "最近升级版本",
      key: "version",
      minWidth: 90
    },
    {
      title: "升级时间",
      key: "upgradeTime",
      minWidth: 85
    },
    {
      title: "升级结果",
      key: "upgradeResult",
      minWidth: 60
    },
    {
      title: "调试时间",
      key: "debugTime",
      minWidth: 85
    },
    {
      title: "调试结果",
      key: "debugResult",
      minWidth: 60
    },
    {
      title: "操作",
      minWidth: 80,
      slot: "action"
    }
  ];

  public queryClick(): void {
    this.formInline.pageNo = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.pageNo = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.pageSize = val;
    this.getTableList();
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.type = "";
      this.formInline.field = "";
    } else {
      this.formInline.type = column.order;
      this.formInline.field = "u." + column.key;
    }
    this.getTableList();
  }
  public selectItem(list: object[]): void {
    this.selectList = list;
  }

  public queryItem(item: objAny): void {
    this.devDetails.open(item);
  }

  public debugMore(): void {
    const arr: string[] = [];
    this.selectList.map((item: objAny) => {
      arr.push(item.serialNumber);
    });
    this.devDebug.open(arr);
  }

  public upgradeMore(): void {
    const arr: string[] = [];
    this.selectList.map((item: objAny) => {
      arr.push(item.serialNumber);
    });
    this.updataUpgradePack.open(arr);
  }
  public upgradeItem(item: objAny): void {
    this.updataUpgradePack.open([item.serialNumber]);
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDeviceList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  mounted() {
    this.getTableList();
    this.$nextTick(() => {
      this.updataUpgradePack = this.$refs["updataUpgradePack"];
      this.devDetails = this.$refs["devDetails"];
      this.devDebug = this.$refs["devDebug"];
    });
  }
}
